const CREATE_KEY_STEPS_ENUM = {
  create: 'CreateKey',
  all: 'AllKey',
  custom: 'CustomKey'
}

export default CREATE_KEY_STEPS_ENUM
